import React from "react";
import ReactMarkdown from "react-markdown";
import * as firebase from "firebase";
import "./Bot.css";
import bot from "./BotMd";
import google from "../../assets/img/google.png";

const signIn = () => {
  const provider = new firebase.auth.GoogleAuthProvider();
  provider.addScope("https://www.googleapis.com/auth/drive.metadata.readonly");
  firebase
    .auth()
    .signInWithPopup(provider)
    .then(result => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      const token = result.credential.accessToken;
      alert(token);
      // var user = result.user;
    })
    .catch(error => {
      console.log(error);
    });
};

const Bot = () => (
  <div className="bot">
    <div>
      <ReactMarkdown source={bot} className="text" />
    </div>
    <div>
      <a href="https://slack.com/oauth/authorize?client_id=379832235377.380154477524&scope=incoming-webhook,bot">
        <img
          alt="Add to Slack"
          height="40"
          width="139"
          src="https://platform.slack-edge.com/img/add_to_slack.png"
          srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
        />
      </a>
    </div>
    <div>
      <div
        onClick={signIn}
        style={{ cursor: "pointer" }}
        role="button"
        tabIndex="0"
      >
        <img alt="Sign in with google" src={google} />
      </div>
    </div>
  </div>
);

export default Bot;



// WEBPACK FOOTER //
// ./src/pages/Bot/Bot.js